// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  display: none !important;
}

.active {
  background-color: #8dc63f;
  color: white;
}

.filter-status-label {
  align-self: flex-start;
  padding: 5px;
  font-weight: bold;
}

.status-list {
  margin-top: 70px;
  margin-right: 50px;
  width: auto;
  position: absolute;
  background-color: rgb(240, 240, 240);
  padding: 10px;
  border-radius: 5px;
  z-index: 2;
  max-height: 40vh;
  overflow-y: scroll;
  box-shadow: 3px 2px 5px 2px rgba(0, 0, 0, 0.75);
  -webkit-box-shadow: 3px 2px 5px 2px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 2px 5px 2px rgba(0, 0, 0, 0.75);
}
.status-list .status-input-container {
  display: flex;
  flex-direction: row;
  border-radius: 5px;
  padding: 3px;
}
.status-list .status-input-container input {
  width: 15px !important;
  cursor: pointer;
}
.status-list .status-input-container label {
  cursor: pointer;
  margin-left: 5px;
}
.status-list .status-input-container:hover {
  background-color: rgb(214, 214, 214);
}

.status-filter {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.status-filter .dropdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  width: 275px;
  height: 32px;
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
}
.status-filter .dropdown-container:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/status-filter/status-filter.styles.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;EACA,uDAAA;EACA,oDAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AAAI;EACE,sBAAA;EACA,eAAA;AAEN;AAAI;EACE,eAAA;EACA,gBAAA;AAEN;AAEE;EACE,oCAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iDAAA;AADJ;AAGI;EACE,eAAA;AADN","sourcesContent":[".hidden {\n  display: none !important;\n}\n\n.active {\n  background-color: #8dc63f;\n  color: white;\n}\n\n.filter-status-label {\n  align-self: flex-start;\n  padding: 5px;\n  font-weight: bold;\n}\n\n.status-list {\n  margin-top: 70px;\n  margin-right: 50px;\n  width: auto;\n  position: absolute;\n  background-color: rgb(240, 240, 240);\n  padding: 10px;\n  border-radius: 5px;\n  z-index: 2;\n  max-height: 40vh;\n  overflow-y: scroll;\n  box-shadow: 3px 2px 5px 2px rgba(0, 0, 0, 0.75);\n  -webkit-box-shadow: 3px 2px 5px 2px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 3px 2px 5px 2px rgba(0, 0, 0, 0.75);\n\n  .status-input-container {\n    display: flex;\n    flex-direction: row;\n    border-radius: 5px;\n    padding: 3px;\n    input {\n      width: 15px !important;\n      cursor: pointer;\n    }\n    label {\n      cursor: pointer;\n      margin-left: 5px;\n    }\n  }\n\n  .status-input-container:hover {\n    background-color: rgb(214, 214, 214);\n  }\n}\n\n.status-filter {\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n\n  .dropdown-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    width: 275px;\n    height: 32px;\n    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
